import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isNonProduction() {
  const hostname = window.location.hostname;

  return (
    hostname.includes("localhost") ||
    hostname.includes("vercel.app") ||
    hostname.includes("staging") ||
    hostname.startsWith("staging.") ||
    hostname.startsWith("checkout-staging.")
  );
}

export function resolveFlexSiteHostname() {
  if (isNonProduction()) {
    return "https://flex-staging.refurbly.se";
  }

  return "https://flex.refurbly.se";
}

/** Build a Flex site URL with the active locale prefix (/en or /sv). */
export function resolveFlexSiteUrl(path = "/", lang?: string | null) {
  const hostname = resolveFlexSiteHostname();
  const locale = lang === "en" ? "en" : "sv";
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const rest = normalized === "/" ? "" : normalized;
  return `${hostname}/${locale}${rest}`;
}

export type CheckoutLanguage = "en" | "sv";

/** Read checkout locale from the URL path (e.g. /en/:orderId → en). */
export function getCheckoutLanguageFromPath(
  pathname = typeof window !== "undefined" ? window.location.pathname : "/"
): CheckoutLanguage {
  const segment = pathname.split("/").filter(Boolean)[0];
  return segment === "en" ? "en" : "sv";
}

/** True only on localhost (127.0.0.1 or localhost). Used for BankID mock. */
export function isLocalhost() {
  const hostname = window.location.hostname;
  return hostname === "localhost" || hostname === "127.0.0.1";
}
